import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    isPermanent() {
      return this.value.custom19 === 'permanent'
    }
  },

  render
}
